export default function scriptsSolucoes() {

  function tabsSwap(parentWrapper, goTo) {
    // TABS
    let tabs = document.querySelectorAll(`${parentWrapper} .tab`);
    let tabContents = document.querySelectorAll(
      `${parentWrapper} .tab-content`,
    );
    const tabContentContainer = document.querySelector(
      `${parentWrapper} .tabs-content-wrapper`,
    );

   
    if (!tabs) return;

    tabs.forEach(function (tab) {
      
      tab.addEventListener('click', function () {
        let contentId = this.dataset.contentId;
        let content = document.getElementById(contentId);
        
        console.log(contentId, content)
        tabContents.forEach(function (content) {
          content.classList.remove('active');
        });

        tabs.forEach(function (tab) {
          tab.classList.remove('active');
        });

        this.classList.add('active');
        content.classList.add('active');
        if (goTo) {
          tabContentContainer.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  }
  tabsSwap('#solucoes');
  // tabsSwap('#faq' );

  //   function tabsSwap(){
  //     // TABS
  //     let tabs = document.querySelectorAll(".tab");
  //     let tabContents = document.querySelectorAll(".tab-content");

  //     if(!tabs) return;
  //     tabs.forEach(function (tab) {
  //     tab.addEventListener("click", function () {
  //         let contentId = this.dataset.contentId;
  //         let  content = document.getElementById(contentId);

  //         tabContents.forEach(function (content) {
  //         content.classList.remove("active");
  //         });

  //         tabs.forEach(function (tab) {
  //         tab.classList.remove("active");
  //         });

  //         this.classList.add("active");
  //         content.classList.add("active");
  //     });
  //     });
  //  }
  //  tabsSwap();

      const swiperSolucoesTabs = new Swiper('.swiper-solucoes-tabs', {
      slidesPerView: 'auto',
      observer: true,
      slideToClickedSlide: true,
      breakpoints: {
        1024: {
          slidesPerView: 'auto',
        },
        1200: {
          slidesPerView: 'auto',
        },
      },
    });



  const swiperDepoimentos = new Swiper('.swiper-depoimentos', {
    slidesPerView: 1.2,
    spaceBetween: 16,
    // autoplay:{
    // delay: 4000,
    // disableOnInteractio: false,
    // pauseOnMouseEnter: true
    // },
    breakpoints: {
      740: {
        slidesPerView: 2.2,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 3.2,
        spaceBetween: 16,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 32,
      },
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.custom-next',
      prevEl: '.custom-prev',
    },
  });

  const swiperTabsFaq = new Swiper('.swiper-tabs-faq', {
    slidesPerView: 'auto',
    spaceBetween: 8,
  });
  function changeContentActiveBaseOnUrl() {
    const params = new URLSearchParams(window.location.search)
   
    if(!params.get('tab')) return

    let tabs = document.querySelectorAll('#solucoes .tab');
    let tabsContent = document.querySelectorAll('#solucoes .tab-content');
    // let urlId = window.location.hash
    let urlId =  `#${params.get('tab')}`
    let theSlideIndex = +urlId.slice(-1)

    if(theSlideIndex ==  0) return
    if (!tabs) return;
    if(!urlId) return;
   

   
    if( theSlideIndex  > tabs.length ) {

      return
    }
    tabsContent.forEach(content => content.classList.remove('active'))
 
    tabs.forEach((tab) => {
   
      tab.classList.remove('active')

        if ('#' + tab.dataset.contentId === urlId) {
          tab.classList.add('active');
          document.querySelector(urlId).classList.add('active');
          console.log('RODEI')
         swiperSolucoesTabs.slideTo(theSlideIndex - 1);
    
       
         
       
        }
     
    });
   
  

    return +theSlideIndex;
  }

  window.addEventListener('DOMContentLoaded', () => {
    changeContentActiveBaseOnUrl();
  
  })

}
